export default "__VITE_ASSET__CPCzKT63__"